export default "<div class=\"statistic-chart\">\n  <div class=\"statistic-chart_title\">{{ title }}</div>\n  <div id=\"statistic-chart\"></div>\n</div>\n"